/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

'use es6';

import PropTypes from 'prop-types';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { trackDashboardInteraction } from 'EmailComponents/utils/tracking';
import ToolAccessTooltip from 'ui-tool-access/ToolAccessTooltip';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UIButton from 'UIComponents/button/UIButton';
import { memo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const VIEW_EMAIL_USAGE_ACTION = 'viewEmailAccessRequestTooltip';
function CreateEmailButtonTooltips({
  children,
  hasActiveDomains,
  hasEmailCreatePermission,
  isProductReadOnly
}) {
  if (isProductReadOnly) {
    return /*#__PURE__*/_jsx(UITooltip, {
      onOpenChange: event => {
        const isOpen = event.target.value;
        if (isOpen && !hasEmailCreatePermission && !isProductReadOnly) {
          trackDashboardInteraction({
            otherActions: VIEW_EMAIL_USAGE_ACTION
          });
        }
      },
      placement: "left",
      title: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        "data-test-id": "read-only-tooltip",
        message: "EmailComponents.emailCreation.disabled.portalReadOnly"
      }),
      children: children
    });
  } else if (!hasEmailCreatePermission) {
    return /*#__PURE__*/_jsx(ToolAccessTooltip, {
      scope: "email-write",
      tooltipProps: {
        // Any props that UITooltip expects
        ['data-test-id']: 'no-create-permission-tooltip',
        placement: 'left',
        onOpenChange: event => {
          const isOpen = event.target.value;
          if (isOpen && !hasEmailCreatePermission && !isProductReadOnly) {
            trackDashboardInteraction({
              otherActions: VIEW_EMAIL_USAGE_ACTION
            });
          }
        }
      },
      children: children
    });
  }
  if (!hasActiveDomains) {
    return /*#__PURE__*/_jsx(UITooltip, {
      "data-test-id": "no-active-domain-tooltip",
      disabled: hasActiveDomains,
      headingText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "EmailComponents.emailCreation.disabled.noActiveDomain.title"
      }),
      use: "longform",
      placement: "bottom",
      title: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        elements: {
          UIButton: ({
            children: _children
          }) => /*#__PURE__*/_jsx(UIButton, {
            onClick: () => window.location.reload(),
            use: "link",
            children: _children
          })
        },
        message: "EmailComponents.emailCreation.disabled.noActiveDomain.body_jsx"
      }),
      children: children
    });
  }
  return children;
}
CreateEmailButtonTooltips.propTypes = {
  children: PropTypes.node.isRequired,
  hasActiveDomains: PropTypes.bool.isRequired,
  hasEmailCreatePermission: PropTypes.bool.isRequired,
  isProductReadOnly: PropTypes.bool.isRequired,
  shouldDisableCreateEmailAction: PropTypes.bool.isRequired
};
export default /*#__PURE__*/memo(CreateEmailButtonTooltips);